/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD9TimeseriesResponseDto } from '../../models/backend-d-9-timeseries-response-dto';

export interface GetTimeseriesDashboardsD9TimeseriesGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;

  /**
   * ID сценария; если не задан — берётся активный по проекту
   */
  scenario_id?: number | null;

  /**
   * Начало периода YYYY-MM-DD; дефолт — последние 12 месяцев данных
   */
  from?: string | null;

  /**
   * Конец периода YYYY-MM-DD; дефолт — последняя дата данных
   */
  to?: string | null;

  /**
   * Гранулярность бакета
   */
  granularity?: 'month' | 'quarter' | 'year';
}

export function getTimeseriesDashboardsD9TimeseriesGet(
  http: HttpClient,
  rootUrl: string,
  params: GetTimeseriesDashboardsD9TimeseriesGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD9TimeseriesResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getTimeseriesDashboardsD9TimeseriesGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD9TimeseriesResponseDto>;
    }),
  );
}

getTimeseriesDashboardsD9TimeseriesGet.PATH = '/dashboards/d9/timeseries';
